export const setLastSelectedProduct = (product) => (dispatch, getState) => {
    // console.log('setLastSelectedProduct', product)
    dispatch({ type: 'SET_LAST_SELECTED_PRODUCT', product})
}

export const setLastRouteId = (routeId) => (dispatch, getState) => {
    // console.log('ROUTEE', routeId)
    // dispatch({ type: 'SET_LAST_ROUTE_ID', routeId})
}

// export const addConfigurableInProgress = (configs) => (dispatch) => {
//     return new Promise((resolve) => {
//         configs.forEach(config => {
//             dispatch({
//                 type: 'ADD_CONFIGURABLE_IN_PROGRESS',
//                 refcode: config.reference,
//                 configData: config
//             })
//         })
//         resolve()
//     })
// }

export const addConfigurableInProgress = (parentRefCode, config) => (dispatch) => {
    return new Promise((resolve) => {
        dispatch({
            type: 'ADD_CONFIGURABLE_IN_PROGRESS',
            refcode: parentRefCode,
            configData: config
        })
        resolve()
    })
}

export const addConfigurablePlanAcceptanceChecked = (refcode, checked = false) => (dispatch) => {
    return new Promise((resolve) => {
        dispatch({
            type: 'ADD_CONFIGURABLE_PLAN_ACCEPTANCE_CHECKED',
            refcode,
            isPlanAcceptanceChecked: checked
        })

        resolve()
    })
}

export const addConfigurableModifiedList = (refcode, isModified = false) => (dispatch) => {
    dispatch({
        type: 'ADD_CONFIGURABLE_MODIFIED_LIST',
        refcode,
        isConfigurableModified: isModified
    })
}